import { render, staticRenderFns } from "./BaseInputPhone.vue?vue&type=template&id=4b32dd88&scoped=true"
import script from "./BaseInputPhone.vue?vue&type=script&lang=ts"
export * from "./BaseInputPhone.vue?vue&type=script&lang=ts"
import style0 from "./BaseInputPhone.vue?vue&type=style&index=0&id=4b32dd88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32dd88",
  null
  
)

export default component.exports